import Button, { ButtonVariants } from '@pixum/button';
import Text, { TextVariant } from '@pixum/text';
import { UploadErrorApplyForEveryXElements } from '../../UploadErrorApplyForEveryXElements';
import styles from './UploadErrorContactSupport.module.css';

interface UploadErrorContactSupportProps {
  errorCount: number;
  applyForAll: boolean;
  onApplyForAllChange: (checked: boolean) => void;
  onRemove: () => void;
  constants: Record<string, string>;
}

export function UploadErrorContactSupport({
  errorCount,
  applyForAll,
  onApplyForAllChange,
  onRemove,
  constants
}: UploadErrorContactSupportProps) {
  return (
    <div className={styles.uploadErrorContactSupport}>
      <div className={styles.uploadErrorContactSupportActions}>
        {errorCount > 1 && (
          <UploadErrorApplyForEveryXElements
            numOfErrors={errorCount}
            checked={applyForAll}
            constants={constants}
            onChange={onApplyForAllChange}
          />
        )}
        <a href="/service" rel="noreferrer" target="_blank">
          <Text variant={TextVariant.CAPTION}>{constants['i18n_help_and_support']}</Text>
        </a>
        <Button variant={ButtonVariants.SECONDARY} onClick={onRemove}>
          {constants['i18n_remove_photo']}
        </Button>
      </div>
    </div>
  );
}
